import { VueQueryPlugin } from "@tanstack/vue-query"
import { createPinia } from "pinia"
import { createApp } from "vue"

import App from "@/App.vue"
import { router } from "@/app/providers/router"
import { useSessionStore } from "@/entities/session"
import { setSessionExpiredHandler } from "@/shared/api/http"
import { applyDocumentLocale, i18n } from "@/shared/config/i18n"

// tailwind-compat (not tailwind) — it keeps the button background so Naive UI's
// `[type=button]`-specificity styles aren't reset to transparent. See design-system.
import "@unocss/reset/tailwind-compat.css"
import "virtual:uno.css"
import "@/app/styles/main.css"

const app = createApp(App)

applyDocumentLocale()

app.use(createPinia())

const session = useSessionStore()

// The HTTP layer refreshes expired access tokens on its own; this fires only
// when the refresh token is gone too, i.e. the session is unrecoverable.
setSessionExpiredHandler(() => {
  session.expire()
  const redirect = router.currentRoute.value.fullPath
  void router.replace({ name: "login", query: { redirect } })
})

// Revalidate any token persisted from a previous visit. The store hydrates
// synchronously from localStorage, so the router guard already has an answer;
// this just confirms the token server-side and refreshes roles/permissions.
void session.restore()

app
  .use(router)
  .use(i18n)
  .use(VueQueryPlugin)
  .mount("#app")
